module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mu-d7d71f034d81a71053730203f958dca1.svg";